<!-- 内容显示、输入、跳转操作面板 -->
<template>
    <div class="pub-field" @click="fieldHandle" v-if="customType > 30">
        <div class="pub-field-title" :style="'height:' + customHeight + (customHeightUnit>0?'%;':'rem;')"
        v-if="customHeight>0"></div>
        <div class="pub-field-title" v-else></div>
        <slot></slot>
        <span class="pub-end-text" v-if="endText && endText!=''">{{endText}}</span>
        <span class="pub-field-fold" 
        :class="{'down':fieldType>34 || fieldType==26}"
        v-if="fieldType>30 || fieldType==25 || fieldType==26"></span>
    </div>
    <div class="pub-field" @click="fieldHandle" v-else>
        <div class="pub-field-title" :class="[{'characters4':isCumtomFieldTitleCharacters && fieldTitleCharacters==4}]" v-if="fieldTitle">{{fieldTitle}}</div>
        <div class="pub-field-ipt-wrap" 
        :class="[{'align-right':fieldType==33 || fieldType==34 || fieldType==37 || fieldType==38
        || fieldType==23 || fieldType==24},
        {'custom':inputType==2}]"
        v-if="fieldType>11 && fieldType!= 25 && fieldType!=26">
            <div class="pub-field-cont" v-if="fieldType%2 > 0">
                <span class="field-cont" v-if="fieldValue">{{fieldValue}}</span>
                <span class="pub-field-cont-tip" v-else-if="valuePlaceholder">{{valuePlaceholder}}</span>
            </div>
            <textarea class="field-ipt textarea" type="text" v-model="cacheFieldValue"
            :maxlength="valueMaxLength" :placeholder="valuePlaceholder" v-else-if="inputType==2"></textarea>
            <input class="field-ipt" type="number" v-model="cacheFieldValue"
            :maxlength="valueMaxLength" :placeholder="valuePlaceholder"
            @keyup="onlyNumber" @focus="fieldIptFocus" @blur="fieldIptBlur" v-else-if="fieldValueType==2 && !isFieldDisabled">
            <input class="field-ipt" type="number" v-model="cacheFieldValue"
            :maxlength="valueMaxLength" :placeholder="valuePlaceholder" disabled
            @keyup="onlyNumber" @focus="fieldIptFocus" @blur="fieldIptBlur" v-else-if="fieldValueType==2 && isFieldDisabled">
            <input class="field-ipt" type="text" v-model="cacheFieldValue"
            :maxlength="valueMaxLength" :placeholder="valuePlaceholder" disabled
            @focus="fieldIptFocus" @blur="fieldIptBlur" v-else-if="isFieldDisabled">
            <input class="field-ipt" type="text" v-model="cacheFieldValue"
            :maxlength="valueMaxLength" :placeholder="valuePlaceholder"
            @focus="fieldIptFocus" @blur="fieldIptBlur" v-else>
        </div>
        <span class="pub-end-text" v-if="endText && endText!=''">{{endText}}</span>
        <span class="pub-field-fold" 
        :class="{'down':fieldType>34 || fieldType==26}"
        v-if="fieldType>30 || fieldType==25 || fieldType==26"></span>
    </div>
</template>
<style>
.pub-field{
    width: 92%;
    padding: 0.2rem 4%;
    border-bottom: 1px solid #b5b6b6;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 0.28rem;
    color: #6a6f71;
    line-height: 0.5rem;
    position: relative;
    transition: all .5s ease;
}
/* 操作项标题 */
.pub-field .pub-field-title{
    flex: 0 0 auto;
    align-self: flex-start;
    margin-right: 0.26rem;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}
.pub-field .pub-field-title.characters4{
    width: 1.14rem;
}
/* 内容、输入框 */
.pub-field .pub-field-ipt-wrap{
    flex: 1 1 auto;
    height: 0.5rem;
    text-align: left;
    font-size: 0.28rem;
    position: relative;
}
.pub-field .pub-field-ipt-wrap.custom{
    height: auto;
}
.pub-field .pub-field-ipt-wrap .pub-field-cont{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}
.pub-field .pub-field-ipt-wrap .pub-field-cont .field-cont{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #231815;
    line-height: 0.5rem;
}
.pub-field .pub-field-ipt-wrap .pub-field-cont .pub-field-cont-tip{
    color: #b5b6b6;
}
.pub-field .pub-field-ipt-wrap input,
.pub-field .pub-field-ipt-wrap .field-ipt{
    width: 100%;
    height: 0.5rem;
    padding: 0;
    background: #ffffff;
    text-align: left;
    font-size: 0.28rem;
    font-family: Arial, Helvetica, sans-serif, "microsoft yahei";
    transition: all .5s ease;
}
.pub-field .pub-field-ipt-wrap .field-ipt.textarea{
    height: 1.4rem;
    resize: none;
    border: 0;
    line-height: 0.4rem;
    padding: 0.06rem 0;
    outline: 0;
}

.pub-field .pub-field-ipt-wrap input::-webkit-input-placeholder{
    color: #b5b6b6 !important;
}
.pub-field .pub-field-ipt-wrap input:-moz-placeholder{
    color: #b5b6b6 !important;
}
.pub-field .pub-field-ipt-wrap input::-moz-placeholder{
    color: #b5b6b6 !important;
}
.pub-field .pub-field-ipt-wrap input:-ms-input-placeholder{
    color: #b5b6b6 !important;
}
.pub-field .pub-field-ipt-wrap .field-ipt::-webkit-input-placeholder{
    color: #b5b6b6 !important;
}
.pub-field .pub-field-ipt-wrap input:focus,
.pub-field .pub-field-ipt-wrap input:active{
    transition: all .5s ease;
}
.pub-field .pub-field-ipt-wrap.align-right,
.pub-field .pub-field-ipt-wrap.align-right input{
    text-align: right;
}
.pub-field .pub-field-ipt-wrap.align-right .pub-field-cont{
    justify-content: flex-end;
}

.pub-field .pub-end-text{
    flex: 0 0 auto;
    margin-left: 0.2rem;
}
.pub-field .pub-field-fold{
    flex: 0 0 auto;
    margin-left: 0.2rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    text-align: right;
}
.pub-field .pub-field-fold:after{
    content: "";
    width: 0.15rem;
    height: 0.15rem;
    border-top: 1px solid #b5b6b6;
    border-right: 1px solid #b5b6b6;
    transform: rotate(45deg);
    display: inline-block;
    position: relative;
}
.pub-field .pub-field-fold.down:after{
    border-top: 0;
    border-bottom: 1px solid #b5b6b6;
}
.pub-field.active{
    border-color: #f0861b;
    transition: all .5s ease;
}
</style>
<script>
export default {
    props: {
        //类型:
        //31:三列(标题、左对齐文本内容、右箭头),32:三列(标题、左对齐输入框内容、右箭头),
        //33:三列(标题、右对齐文本内容、右箭头),34:三列(标题、右对齐输入框内容、右箭头),
        //35:三列(标题、左对齐文本内容、下箭头),36:三列(标题、左对齐输入框内容、下箭头),
        //37:三列(标题、右对齐文本内容、下箭头),38:三列(标题、右对齐输入框内容、下箭头),

        //21:两列(标题、左对齐文本内容),22:两列(标题、左对齐输入框内容),
        //23:两列(标题、右对齐文本内容),24:两列(标题、右对齐输入框内容),
        //25:两列(标题、右箭头),26:两列(标题、下箭头),

        //11:一列(标题),12:一列(左对齐输入框内容),
        fieldType: {
            type: Number,
            default: 1
        },
        fieldTitle: { //当前项的标题
            type: String,
            default: ""
        },
        isCumtomFieldTitleCharacters: { //是否定制标题字符数
            type: Boolean,
            default: false
        },
        fieldTitleCharacters: { //当前项标题的字符数
            type: Number,
            default: 4
        },
        fieldValue: { //当前项的值
            type: String|Number,
            default: ""
        },
        fieldValueType: { //输入框类型: 1:text, 2:number, 3:tel
            type: Number,
            default: 1
        },
        fieldName: { //输入框绑定的字段名
            type: String,
            default: ""
        },
        valueMaxLength: { //当前项的值最大长度
            type: Number,
            default: 50
        },
        valuePlaceholder: { //当前项的值提示文案
            type: String,
            default: ""
        },
        inputType: { //输入框类型: 1:文本框, 2:文本域
            type: Number,
            default: 1
        },
        endText: { //结尾文案
            type: String,
            default: ""
        },
        isClearField: { //是否清空field数据
            type: Boolean,
            default: false
        },
        isFieldDisabled: { //是否field不可编辑
            type: Boolean,
            default: false
        },
        isFieldActive: { //当前项是否激活状态
            type: Boolean,
            default: false
        },
        customType: { //自定义内容类型: 0:无, 31:留右箭头
            type: Number,
            default: 0
        },
        customHeight: { //自定义高度
            type: Number,
            default: 0
        },
        customHeightUnit: { //自定义高度单位: 0:rem, 1:%
            type: Number,
            default: 0
        },
    },
	data () {
		return {
			cacheFieldValue: "",
		}
    },
    mounted(){
        this.cacheFieldValue = this.fieldValue;
    },
    watch: {
        cacheFieldValue(){//即时返回输入框内容
            if(this.fieldType>11 && this.fieldType!=26 && this.fieldType%2==0){
                this.$emit("watchField",this.fieldName,this.cacheFieldValue);
            }
        },
        isClearField(){
            if(this.isClearField){//清空输入框缓存数据
                this.cacheFieldValue = "";
            }
        },
    },
	methods: {
        //面板点击事件
        fieldHandle() {
            this.$emit("fieldHandle");
        },
        //只能输入数字
        onlyNumber(){
            this.cacheFieldValue = this.cacheFieldValue ? this.cacheFieldValue.toString().replace(/[^\d]/g,'') : '';
        },
        //外部更新调用
        updateFieldValue(paramValue){
            this.cacheFieldValue = paramValue;
        },
        //输入框聚焦事件
        fieldIptFocus(){
            this.$emit("fieldIptFocus",this.fieldName,this.cacheFieldValue);
        },
        //输入框失焦事件
        fieldIptBlur(){
            this.$emit("fieldIptBlur",this.fieldName,this.cacheFieldValue);
        },
	}
}
</script>


// WEBPACK FOOTER //
// src/shared/components/control/field.vue